import { Stack, styled } from "@mui/material";

export const RankBadge = styled(Stack)`
  padding: 4px 7px;
  align-items: center;
  gap: 4px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
`;
